import { render, staticRenderFns } from "./releaseAgentDetail.vue?vue&type=template&id=2a16171e&scoped=true&"
import script from "./releaseAgentDetail.vue?vue&type=script&lang=js&"
export * from "./releaseAgentDetail.vue?vue&type=script&lang=js&"
import style0 from "./releaseAgentDetail.vue?vue&type=style&index=0&id=2a16171e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a16171e",
  null
  
)

export default component.exports